import { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";

export const NewImage = ({
    url,
    fileName,
}: {
    url: string;
    fileName: string;
}) => {
    const [colorized, setColorized] = useState("");
    const [err, setErr] = useState("");

    const colorizeImage = (url: string, fileName: string) => {
        axios
            .post("https://beam-api-fp50.onrender.com/upload/" || "", {
                url: url,
                fileName: fileName,
            })
            .then(function (response) {
                setColorized(response.data.colorized);
            })
            .catch(function (error) {
                setErr(error.message);
            });
    };

    useEffect(() => {
        colorizeImage(url, fileName);
        // eslint-disable-next-line
    }, []);

    return (
        <div className="flex flex-col items-center">
            {err !== "" ? (
                <div
                    className="p-3 mb-4 text-xs text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800"
                    role="alert"
                >
                    {err}
                </div>
            ) : (
                <h1
                    className={`text-2xl font-extrabold ${
                        colorized === "" ? "text-gray-600" : "text-green-500"
                    } dark:text-white md:text-2xl lg:text-2xl max-sm:text-center`}
                >
                    Your image{" "}
                    {colorized === "" ? (
                        <span className="animate-pulse text-slate-400">
                            is being
                        </span>
                    ) : (
                        <span>has been</span>
                    )}{" "}
                    processed {colorized !== "" && <span>🚀</span>}
                </h1>
            )}

            <div className="flex my-3 items-center justify-center gap-1 w-full max-sm:flex-col">
                <img
                    className="w-auto h-60 shadow-xl rounded-xl m-2"
                    src={url}
                    alt="default"
                />{" "}
                {colorized === "" ? (
                    <div className="flex items-center h-full w-full">
                        <svg
                            role="status"
                            className="text-blue-600 inline w-full h-6 animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                ) : (
                    <img
                        className="w-auto h-60 shadow-xl rounded-xl m-2"
                        src={colorized}
                        alt="default"
                    />
                )}
            </div>
            {colorized !== "" && (
                <div className="flex mt-3 flex-row">
                    <button
                        type="button"
                        className="text-white bg-[#050708] hover:bg-[#050708]/90 focus:ring-4 focus:outline-none focus:ring-[#050708]/50 font-medium rounded-lg text-sm px-5 pt-2.5 pb-2 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 mr-2 mb-2"
                        onClick={() => {
                            saveAs(colorized, "colorized_" + fileName);
                        }}
                    >
                        <svg
                            className="mr-2 mb-1 -ml-1 w-4 h-4"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fab"
                            data-icon="download"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path
                                fill="currentColor"
                                d="M12 2.25a.75.75 0 01.75.75v11.69l3.22-3.22a.75.75 0 111.06 1.06l-4.5 4.5a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 111.06-1.06l3.22 3.22V3a.75.75 0 01.75-.75zm-9 13.5a.75.75 0 01.75.75v2.25a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5V16.5a.75.75 0 011.5 0v2.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V16.5a.75.75 0 01.75-.75z"
                            />
                        </svg>
                        Download
                    </button>
                    <a
                        href={
                            "https://twitter.com/intent/tweet?text=I just had my old black and white photo colorized checkout&url=https://beam-ai.onrender.com"
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button
                            type="button"
                            className="text-white bg-[#1da1f2] hover:bg-[#1da1f2]/90 focus:ring-4 focus:outline-none focus:ring-[#1da1f2]/50 font-medium rounded-lg text-sm px-5 pt-2.5 pb-2  text-center inline-flex items-center dark:focus:ring-[#1da1f2]/55 mr-2 mb-2"
                        >
                            <svg
                                className="mr-2 mb-1 -ml-1 w-4 h-4"
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fab"
                                data-icon="twitter"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M459.4 151.7c.325 4.548 .325 9.097 .325 13.65 0 138.7-105.6 298.6-298.6 298.6-59.45 0-114.7-17.22-161.1-47.11 8.447 .974 16.57 1.299 25.34 1.299 49.06 0 94.21-16.57 130.3-44.83-46.13-.975-84.79-31.19-98.11-72.77 6.498 .974 12.99 1.624 19.82 1.624 9.421 0 18.84-1.3 27.61-3.573-48.08-9.747-84.14-51.98-84.14-102.1v-1.299c13.97 7.797 30.21 12.67 47.43 13.32-28.26-18.84-46.78-51.01-46.78-87.39 0-19.49 5.197-37.36 14.29-52.95 51.65 63.67 129.3 105.3 216.4 109.8-1.624-7.797-2.599-15.92-2.599-24.04 0-57.83 46.78-104.9 104.9-104.9 30.21 0 57.5 12.67 76.67 33.14 23.72-4.548 46.46-13.32 66.6-25.34-7.798 24.37-24.37 44.83-46.13 57.83 21.12-2.273 41.58-8.122 60.43-16.24-14.29 20.79-32.16 39.31-52.63 54.25z"
                                ></path>
                            </svg>
                            Share
                        </button>
                    </a>
                </div>
            )}
        </div>
    );
};
